
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-full-width-button{
  display:flex;
  justify-content:center;
  align-items:center;
  width:100%;
  padding:var(--spacing-6) var(--spacing-5);
  background-color:var(--brand-secondary-4);
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-bold);
  font-size:var(--fs-lg-mobile);
  color:var(--brand-neutral-gray-800);
  text-decoration:none;
  transition:200ms;
}

  @media (min-width: 768px){.se-full-width-button{
    padding:var(--spacing-8) var(--spacing-4);
    font-size:var(--fs-2xl)
}
  }

  .se-full-width-button__label{
    position:relative;
    display:flex;
    justify-content:center;
    align-items:center;
    gap:var(--spacing-3);
  }

  @media (min-width: 768px){

  .se-full-width-button__label{
      gap:var(--spacing-6)
  }
    }

  .se-full-width-button__label::after{
      content:'';
      transition:200ms;
      position:absolute;
      width:0;
      height:4px;
      top:100%;
      left:0;
      margin-top:0.25rem;
      background:var(--brand-primary-2);
    }

  .se-full-width-button__label > outline-icon{
      transition:200ms;
    }

  .se-full-width-button:hover .se-full-width-button__label > outline-icon{
        transition:200ms;
        transform:translateX(0.25rem);
      }

  @media (min-width: 768px){

  .se-full-width-button:hover .se-full-width-button__label > outline-icon{
          transform:translateX(1rem)
      }
        }

  .se-full-width-button:hover .se-full-width-button__label::after{
        width:100%;
      }

  .se-full-width-button--left .se-full-width-button__label::after{
        left:auto;
        right:0;
      }

  .se-full-width-button--left:hover .se-full-width-button__label > outline-icon{
          transform:translateX(-0.25rem);
        }

  @media (min-width: 768px){

  .se-full-width-button--left:hover .se-full-width-button__label > outline-icon{
            transform:translateX(-1rem)
        }
          }
`;